import { render } from "./SingUp.vue?vue&type=template&id=096b4967&scoped=true"
import script from "./SingUp.vue?vue&type=script&lang=js"
export * from "./SingUp.vue?vue&type=script&lang=js"

import "./SingUp.vue?vue&type=style&index=0&id=096b4967&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096b4967"]])

export default __exports__